import * as types from '../constants/ActionTypes'

const reducer = (state, action) => {
  switch (action.type) {
    case types.FETCH_ZGS_NUMBER:
      return { ...state, zgsNum: action.payload }
    default:
      return state
  }
}

export default reducer
